export const NAME = 'changeExam';
